import { render, staticRenderFns } from "./yazy.vue?vue&type=template&id=1bd15bcf&scoped=true&"
import script from "./yazy.vue?vue&type=script&lang=js&"
export * from "./yazy.vue?vue&type=script&lang=js&"
import style0 from "./yazy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./yazy.vue?vue&type=style&index=1&id=1bd15bcf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd15bcf",
  null
  
)

export default component.exports